import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { GenderConst } from '../../planner-edit/constants/Gender.const';
import { AgeRangeConst } from './../../planner-edit/constants/AgeRange.const';
import * as _ from 'lodash';

@Component({
  selector: 'nielsen-demo',
  templateUrl: './nielsen-demo.component.html',
  styleUrls: ['./nielsen-demo.component.scss']
})
export class NielsenDemoComponent implements OnInit {

  @Input() group: string;
  @Input() formArray: FormArray;

  genderConst = GenderConst;
  ageRangeConst = AgeRangeConst;
  rangeSliderConfig: any;
  rangeSelection: any;
  genderKeys = Object.keys(GenderConst);

  constructor() { }

  ngOnInit() {
    let rangeValue = Object.values(this.ageRangeConst);
    this.rangeSliderConfig = {
      step: 1,
      min: rangeValue[0],
      max: rangeValue[rangeValue.length - 1],
      stepLabel: Object.keys(this.ageRangeConst)
    }
    this.updateGenderVO();
  }

  updateGenderVO() {
    let genderValue = this.genderControl.value;
    if (_.size(genderValue) === 0) {
      this.genderControl.patchValue(this.genderConst.All.label);
    } else {
      this.genderControl.patchValue(this.genderConst[genderValue[0]].label);
    }
  }

  onSliderChange(selectedValues: number[]) {
    if (_.size(selectedValues) === 2 && selectedValues[0] !== this.ageMinControl.value && selectedValues[1] !== this.ageMaxControl.value) {
      this.ageMinControl.patchValue(selectedValues[0]);
      this.ageMaxControl.patchValue(selectedValues[1]);
    }
  }

  get nielsenDemoControl(): FormGroup {
    return this.formArray.controls[this.group].get("demoSetting") as FormGroup;
  }

  get ageMinControl(): FormControl {
    return this.nielsenDemoControl.get("ageMin") as FormControl;
  }

  get ageMaxControl(): FormControl {
    return this.nielsenDemoControl.get("ageMax") as FormControl;
  }

  get genderControl(): FormControl {
    return this.nielsenDemoControl.get("gender") as FormControl;
  }

}
